import { SegmentAnalyticsCall } from '../../track-event'
import { transformLegacyDigitalGiftCardPurchase } from './digital-gift-card'
import { transformLegacyDirectPurchase } from './direct'
import { LegacyPurchaseEventData } from './types'

export function transformLegacyPurchase(
  data: LegacyPurchaseEventData
): SegmentAnalyticsCall {
  if (
    hasLegacyPurchaseAffiliation(data, 'Westfield - Digital Gift Card - AU')
  ) {
    return transformLegacyDigitalGiftCardPurchase(data)
  } else if (hasLegacyPurchaseAffiliation(data, 'Westfield - Direct - AU')) {
    return transformLegacyDirectPurchase(data)
  } else {
    const _exhaustive: never = data
    return _exhaustive
  }
}

export function hasLegacyPurchaseAffiliation<A extends string>(
  data: LegacyPurchaseEventData,
  affiliation: A
): data is Extract<LegacyPurchaseEventData, { ecommerce: { affiliation: A } }> {
  return data.ecommerce.affiliation === affiliation
}
